/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_3_1Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_3_table_rows_3_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_3_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the official repository and the documentation for the release you are reviewing.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_3_table_rows_3_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_3_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用官方仓库，并查看所评估版本对应的文档。`)
};

/**
* | output |
* | --- |
* | "Use the official repository and the documentation for the release you are reviewing." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_3_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_3_table_rows_3_1 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_3_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_3_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_3_table_rows_3_1(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_3_table_rows_3_1(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_3_table_rows_3_1 as "gc.search_guides.what_is_gridcraft.sections.3.table.rows.3.1" }